<template>
  <div>
    <v-dialog
      v-model="deleteModal"
      width="600"
      >
      <v-card>
        <v-card-title>
          {{ $t('action.delete') }}
        </v-card-title>

        <v-card-text>
          ¿Está seguro que desea eliminar esta incidencia? Este cambio <strong>no</strong> se puede revertir.
        </v-card-text>

        <v-card-actions
          class="px-6 justify-end"
          >
          <v-btn
            color="primary"
            text
            @click="deleteModal = false"
            >
            Cerrar
          </v-btn>

          <v-btn
            color="red"
            outlined
            @click="deleteTicket"
            >
            Borrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="d-flex flex-row align-center fill-width py-5 white px-8">
      <GoBack 
        class="shrink pr-3"
        />
      <div 
        class="grow"
        >
        <h2
          class="my-2"
          >
          Incidencias
        </h2>
      </div>
      <div 
        class="text-right"
        >
        <v-btn 
          @click.stop="modal = true" 
          outlined
          >
          {{ $t('action.create') }}
        </v-btn>
      </div>
    </div>

    <div
      class="filters_bg px-8 d-flex flex-row"
      style="gap: 12px"
      >
      <v-select
        style="max-width: 200px"
        class="filters_bg grow"
        multiple
        v-model="filters.state"
        :items="states"
        label="Estado"
        solo
        flat
        hide-details
        ></v-select>

      <v-autocomplete
        style="max-width: 400px"
        :rules="[ v => !!v || 'Campo obligatorio.' ]"
        :items="contracts"
        item-text="fullAddress"
        item-value="id"
        v-model="filters.contractId"
        hint="*Obligatorio"
        solo
        flat
        hide-details
        persistent-hint
        clearable
        label="Propiedad">
      </v-autocomplete>
    </div>

    <v-dialog
      v-model="modal"
      width="600"
      >
      <v-card>
        <v-card-title>
          {{ $t('action.create') }}
        </v-card-title>
        <v-card-text>
          <v-form
            v-model="valid"
            lazy-validation
            ref="form"
            >
            <v-row>
              <v-col
                cols="12"
                class="py-0"
                >
                <v-autocomplete
                  :rules="[ v => !!v || 'Campo obligatorio.' ]"
                  :items="contracts"
                  item-text="fullAddress"
                  item-value="id"
                  v-model="ticket.contractId"
                  filled
                  hint="*Obligatorio"
                  persistent-hint
                  label="Contrato">
                </v-autocomplete>
              </v-col>

              <v-col
                cols="6"
                class="py-0"
                >
                <v-text-field
                  label="Título"
                  v-model="ticket.title"
                  filled
                  hint="* Obligatorio"
                  color="primary"
                  :rules="[ v => !!v || 'Campo obligatorio.' ]"
                  ></v-text-field>
              </v-col>

              <v-col
                cols="6"
                class="py-0"
                >
                <v-select
                  :items="states"
                  v-model="ticket.state"
                  filled
                  label="Estado"
                  hint="* Obligatorio"
                  :rules="[ v => !!v || 'Campo obligatorio']"
                  ></v-select>
              </v-col>

              <v-col
                cols="12"
                class="py-0"
                >
                <v-textarea
                  v-model="ticket.descriptionsAttributes[0].description"
                  label="Comentario"
                  filled
                  placeholder="Locatario llama por problema con la cañería del baño."
                  ></v-textarea>
              </v-col>
            </v-row>
          </v-form>

          <div
            class="text-right"
            >
            <v-btn
              @click="createTicket"
              color="primary"
              >
              {{ $t('action.create') }}
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <div
      class="mt-3"
      >
      <v-card
        flat
        class="grey lighten-3 mb-3"
        >
        <v-card-text
          class="py-1"
          >
          <v-row>
            <v-col
              class="py-0"
              cols="3"
              >
              Título
            </v-col>

            <v-col
              class="py-0"
              cols="2"
              >
              Creado
            </v-col>

            <v-col
              class="py-0"
              cols="3"
              >
              Última actualización
            </v-col>

            <v-col
              class="py-0"
              cols="3"
              >
              Estado
            </v-col>

            <v-col
              class="py-0 text-right"
              cols="1"
              >
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <template
        v-for="ticket in tickets"
        >
        <v-card
          class="mb-3"
          >
          <v-card-text>
            <v-row
              class="align-center"
              >
              <v-col
                class="py-0"
                cols="3"
                >
                {{ ticket.title }}
                <div
                  class="caption"
                  >
                  {{ ticket.contract.fullAddress }}
                </div>
              </v-col>

              <v-col
                class="py-0"
                cols="2"
                >
                {{ new Date(ticket.createdAt).toLocaleString() }}
              </v-col>

              <v-col
                class="py-0"
                cols="3"
                >
                {{ new Date(ticket.updatedAt).toLocaleString() }}
              </v-col>

              <v-col
                class="py-0"
                cols="3"
                >
                {{ $t('states.' + ticket.state) }}
              </v-col>

              <v-col
                class="py-0 text-right"
                cols="1"
                >
                <v-btn
                  icon
                  small
                  color="primary"
                  class="mr-3"
                  @click.stop="openDeleteModal(ticket.id)" 
                  >
                  <v-icon
                    >mdi-delete</v-icon>
                </v-btn>
                <v-btn
                  icon
                  small
                  color="primary"
                  @click.stop="$router.push({ name: 'ShowTicket', params: { id: ticket.contract.id, ticket_id: ticket.id } })" 
                  >
                  <v-icon
                    >mdi-eye</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </template>
    </div>
  </div>
</template>

<script>
import { Tickets } from '@/graphql/queries/ticket'
import { AllContracts } from '@/graphql/queries/contract'
import { CreateTicket, DeleteTicket } from '@/graphql/mutations/tickets'
import GoBack from '@/components/GoBack'

export default {
  data () {
    return {
      tickets: [],
      contracts: [],
      valid: true,
      modal: false,
      deleteModal: false,
      selected: null,
      filters: {
        state: null,
        contractId: null,
      },
      ticket: {
        contractId: null,
        title: null,
        state: 'pending',
        descriptionsAttributes: [
          {
            description: null,
          }
        ]
      },
      colors: {
        pending: 'yellow'
      }
    }
  },

  computed: {
    states () { 
      return [
        {
          text: 'Pendiente',
          value: 'pending',
        },
        {
          text: 'En curso',
          value: 'ongoing',
        },
        {
          text: 'Esperando respuesta',
          value: 'on_hold',
        },
        {
          text: 'En observación',
          value: 'watching',
        },
        {
          text: 'Finalizado',
          value: 'success',
        },
      ]
    },
  },

  watch: {
    filters: {
      deep: true,

      handler () {
        this.fetchTickets()
      }
    }
  },

  components: {
    GoBack,
  },

  created () {
    this.fetchTickets()
    this.fetchContracts()
  },

  methods: {
    fetchTickets () {
      this.$apollo.query({
        query: Tickets,
        variables: {
          states: this.filters.state,
          contractId: this.filters.contractId
        },
        fetchPolicy: 'no-cache'
      }).then(res => {
        this.tickets = res.data.tickets
      })
    },

    fetchContracts () {
      this.$apollo.query({
        query: AllContracts,
        fetchPolicy: 'no-cache'
      }).then(res => {
        this.contracts = res.data.allContracts
      })
    },

    createTicket () {
      this.valid = this.$refs.form.validate()

      if (this.valid) {
        this.$apollo.mutate({
          mutation: CreateTicket,
          variables: {
            input: {
              attributes: this.ticket
            }
          }
        }).then(res => {
          this.fetchTickets()
          this.modal = false
        })
      }
    },

    openDeleteModal (id) {
      this.deleteModal = true
      this.selected = id
    },

    deleteTicket () {
      this.$apollo.mutate({
        mutation: DeleteTicket,
        variables: {
          input: {
            id: this.selected
          }
        }
      }).then( res => {
        this.fetchTickets()
        this.deleteModal = false
      })
    },
  }
}
</script>

<style scoped>
>>>.v-input__slot {
  background: transparent !important
}

>>>.v-input__append-outer {
  width: 300px
}

.per-page-select {
  max-width: 80px!important;
  display:inline-block;
}
</style>
